import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
const StudentCommunityProjectRoute = store => {
  return {
    path: ":inviteStep",
    component: withAsyncRouteLoading(
      () =>
        Promise.all([
          import(/* webpackChunkName: "inviteStep" */ "./components"),
        ]).then(([importedModule0]) => {
          const component = importedModule0.default;
          return component;
        })
      // .catch(err => {
      //   throw err;
      // })
    ),
    childRoutes: [],
  };
};
export default StudentCommunityProjectRoute;
